import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import moment from "moment";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import MonthlyComment from "./MonthlyComment";
import LoadingMessage from "@/components/common/LoadingMessage";
import CalendarHeading from "./monthly/CalendarHeading";
import GroupClassSelectForm from "./monthly/GroupClassSelectForm";
import monthlyMixin from "./monthlyMixin";
import { assignAbsentBudge } from "@/services/common";
const __default__ = {
  name: "Summary",
  components: {
    MonthlyComment,
    RowItem,
    LoadingMessage,
    CalendarHeading,
    GroupClassSelectForm
  },
  mixins: [monthlyMixin],

  data() {
    return {
      schoolOffDaysOfYear: {},
      classSchoolOffDaysOfYear: {},
      classMonthData: {},
      students: {},
      attendanceMonthlyComments: [],
      isLoading: true,
      showModal: false,
      selectedStudent: {},
      visibleClassroom: []
    };
  },

  computed: { ...mapState(["grades", "studentAddress", "holidays"]),

    localYearMonth() {
      return moment(this.filter.yearMonth).format("YYYY年MM月");
    },

    currentClassName() {
      const classroom = this.classrooms.find(v => v.id === parseInt(this.filter.classroomId));
      return classroom.name;
    }

  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.filter.yearMonth = this.$route.query.year_month ? this.$route.query.year_month : moment().format("YYYY-MM");
      this.filter.classroomId = this.$route.query.classroom_id ? this.$route.query.classroom_id : 0;
      this.filter.groupId = this.$route.query.group_id ? this.$route.query.group_id : 0; // 1年間の日数を取得し、休日をチェックする

      const fiscalDate = moment(this.filter.yearMonth).add(-3, "month").month(3).startOf("month");
      const fiscalYearDaysLength = fiscalDate.clone().add(1, "years").diff(fiscalDate, "day");
      const schoolOffDaysOfYear = {};

      for (let i = 1; i <= fiscalYearDaysLength; i++) {
        const date = fiscalDate.format("YYYY-MM-DD");

        if (fiscalDate.format("d") === "0" || fiscalDate.format("d") === "6" || this.holidays.includes(date)) {
          schoolOffDaysOfYear[date] = true;
        } else {
          schoolOffDaysOfYear[date] = false;
        }

        fiscalDate.add(1, "day");
      }

      this.schoolOffDaysOfYear = schoolOffDaysOfYear;
      this.setData();
    },

    // クラスを変更した時はinitを経由せずに必要な部分だけ初期化
    handleClassroomChange(classroomId) {
      this.filter.classroomId = classroomId;
      this.setData();
    },

    // グループを変更した時もinitを経由せずに必要な部分だけ初期化
    handleGroupChange(groupId) {
      this.filter.groupId = groupId;
      this.filter.classroomId = 0;
      this.setData();
    },

    async setData() {
      this.isLoading = true;
      const date = moment(this.filter.yearMonth);
      const currentMonth = date.month();
      const startOfMonth = date.clone().startOf("month");
      const endOfMonth = date.clone().endOf("month");
      const fiscalYear = date.clone().add(-3, "month").year();
      const data = await getData(["reader/get_continuously_absent-students", "reader/get_frequently_absent-students", `reader/get_students_with_attendance?fiscal_year=${fiscalYear}&classroom_id=${this.filter.classroomId}&group_id=${this.filter.groupId}`, "events?orderby=updated_at&order=asc&classroom_id=" + this.filter.classroomId + "&fiscal_year=" + fiscalYear, "attendance_monthly_comments?classroom_id=" + this.filter.classroomId + "&start_of_month=" + startOfMonth.format("YYYY-MM-DD")]).catch(error => {
        console.log(error);
      }); // 表示するクラスを整理する

      const selectClassStudentAttendaceObject = data[2].items;
      this.visibleClassroom = [];
      this.classMonthData = {};

      if (this.filter.classroomId === 0) {
        // 全てのクラスを選択したとき
        this.classrooms.forEach(v => {
          if (selectClassStudentAttendaceObject[v.id]) {
            this.visibleClassroom.push(v);
            this.classMonthData[v.id] = structuredClone(this.monthData);
            this.classSchoolOffDaysOfYear[v.id] = structuredClone(this.schoolOffDaysOfYear);
          }
        });
      } else {
        // 個別のクラスを選択したとき
        const classroom = this.classrooms.find(v => v.id === parseInt(this.filter.classroomId));

        if (classroom) {
          this.visibleClassroom.push(classroom);
          this.classMonthData[classroom.id] = structuredClone(this.monthData);
          this.classSchoolOffDaysOfYear[classroom.id] = structuredClone(this.schoolOffDaysOfYear);
        }
      }

      const events = data[3].items;
      events.forEach(v => {
        const from = moment(v.from);
        const to = moment(v.to);

        while (from.isSameOrBefore(to, "day")) {
          v.classroom.forEach(w => {
            if (this.classSchoolOffDaysOfYear[w.classroom_id]) {
              this.classSchoolOffDaysOfYear[w.classroom_id][from.format("YYYY-MM-DD")] = Boolean(v.is_school_day_off);

              if (from.month() === currentMonth && this.classMonthData[w.classroom_id]) {
                this.classMonthData[w.classroom_id][from.date() - 1].isSchoolDayOff = Boolean(v.is_school_day_off);
              }
            }
          });
          from.add(1, "day");
        }
      }); // 長期欠席者

      const absentList3 = data[0].items;
      const absentList20 = data[1].items[0];
      const absentList30 = data[1].items[1]; // 生徒ごとの欠席状況

      this.students = {};
      Object.keys(selectClassStudentAttendaceObject).forEach(classroomId => {
        const classStudentList = selectClassStudentAttendaceObject[classroomId].map(student => {
          const monthlySummary = { ...this.monthlyYearlySummaryTemplate
          }; // mixin

          monthlySummary["要出席日数"] = this.schoolDayLength(classroomId);
          monthlySummary["出席日数"] = this.schoolDayBeforeYearMonthLength(classroomId);
          const yearlySummary = { ...this.monthlyYearlySummaryTemplate
          }; // mixin

          yearlySummary["要出席日数"] = this.schoolDaysOfYearLength(classroomId);
          yearlySummary["出席日数"] = this.schoolDaysOfYearBeforeTodayLength(classroomId);
          const monthlyTypeSummary = {};
          student.attendance.forEach(v => {
            if (this.classSchoolOffDaysOfYear[classroomId][v.date]) {
              return; // 休日のデータは無視する
            }

            if (!v.counting_type) {
              return; // countingTypeがないときはSummaryに含めない
            }

            const countingType = v.counting_type.counting_type;

            if (moment(v.date).isSameOrBefore(endOfMonth)) {
              // mixin
              // year
              this.aggregateStudentSummary(yearlySummary, countingType);

              if (moment(v.date).isBetween(startOfMonth, endOfMonth, null, "[]")) {
                // mixin
                // month
                this.aggregateStudentSummary(monthlySummary, countingType);
                this.aggregateMonthlyTypeSummary(v, monthlyTypeSummary);
              }
            }
          });
          return Object.assign(student, {
            specialAbsents: assignAbsentBudge(student, absentList3, absentList20, absentList30),
            monthlySummary,
            monthlyTypeSummary,
            yearlySummary
          });
        });
        this.students[classroomId] = classStudentList;
      }); // 今月のコメント

      this.attendanceMonthlyComments = data[4].items;
      this.isLoading = false;
    },

    myAttendanceMonthlyComment(studentId) {
      const comment = this.attendanceMonthlyComments.find(v => v.student_id === studentId);

      if (comment) {
        return comment.comment;
      }
    },

    handleCommentEdit(v) {
      this.showModal = true;
      this.selectedStudent = v;
    },

    async getAttendanceMonthlyComments() {
      const data = await getData("attendance_monthly_comments?classroom_id=" + this.filter.classroomId + "&start_of_month=" + moment(this.filter.yearMonth).startOf("month").format("YYYY-MM-DD")).catch(error => {
        console.log(error);
      });
      this.attendanceMonthlyComments = data.items;
    },

    closeModal() {
      // コメント部分だけ更新する
      this.getAttendanceMonthlyComments();
      this.showModal = false;
    },

    schoolDayLength(classroomId) {
      return this.classMonthData[classroomId].filter(v => !v.isSchoolDayOff).length;
    },

    schoolDayBeforeYearMonthLength(classroomId) {
      const yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      const today = moment();

      if (today.isBefore(yearMonth)) {
        return this.classMonthData[classroomId].filter(v => !v.isSchoolDayOff && today.isAfter(v["YYYY-MM-DD"])).length;
      } else {
        return this.classMonthData[classroomId].filter(v => !v.isSchoolDayOff && yearMonth.isAfter(v["YYYY-MM-DD"])).length;
      }
    },

    schoolDaysOfYearLength(classroomId) {
      const yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(k => !this.classSchoolOffDaysOfYear[classroomId][k] && yearMonth.isAfter(moment(k))).length;
    },

    schoolDaysOfYearBeforeTodayLength(classroomId) {
      const yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      const today = moment();

      if (today.isBefore(yearMonth)) {
        return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(k => !this.classSchoolOffDaysOfYear[classroomId][k] && today.isAfter(moment(k))).length;
      } else {
        return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(k => !this.classSchoolOffDaysOfYear[classroomId][k] && yearMonth.isAfter(moment(k))).length;
      }
    }

  }
};
import { ref } from "vue";
import { useMonthData } from "@/composables/monthData";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const {
      classrooms
    } = storeToRefs(useGradeClassroomStore());
    const filter = ref({
      classroomId: 0,
      groupId: 0,
      yearMonth: null
    });
    const {
      monthData,
      days
    } = useMonthData(filter.value);
    expose({
      classrooms,
      filter,
      monthData,
      days
    });
    return {
      __sfc: true,
      classrooms,
      filter,
      monthData,
      days,
      RowItem,
      MonthlyComment,
      LoadingMessage,
      CalendarHeading,
      GroupClassSelectForm
    };
  }

});